import { Icon, IconProps, type SxProps } from "@mui/material";
import { forwardRef } from "react";

const MaterialSymbols = {
  ArticlePerson: "article_person",
  ArticleShortcut: "article_shortcut",
  Bolt: "bolt",
  Gavel: "gavel",
  PersonEdit: "person_edit",
  QuickPhrases: "quick_phrases",
  Target: "target",
  ThumbsUpDouble: "thumbs_up_double",
} as const;

type MaterialSymbolName = (typeof MaterialSymbols)[keyof typeof MaterialSymbols];

interface IProps extends Omit<IconProps, "children" | "baseClassName"> {
  symbol: MaterialSymbolName;
  size?: number | string;
  sx?: SxProps;
}

const MaterialSymbolIcon = forwardRef<HTMLSpanElement, IProps>(({ symbol, size: sizeProp, sx, ...iconProps }, ref) => {
  const size = sizeProp ?? 18;

  return (
    <Icon
      ref={ref}
      baseClassName="material-symbols-outlined"
      sx={{
        fontSize: size,
        ...sx,
      }}
      {...iconProps}
    >
      {symbol}
    </Icon>
  );
});

export { MaterialSymbolIcon, MaterialSymbols };
